import {
  IActiveCollection,
  IGetFiltersResult,
  ISearchFilter,
  ISearchProviderConfig,
} from '../../../types';

/**
 * GetFilters
 *
 * Fetches filter data from the same JSON view used by GetProductResults.
 * The Liquid view should interpret the query string and return:
 *   { filters: ISearchFilter[] }
 */
const GetFilters = (
  _config: ISearchProviderConfig,
  activeCollection: IActiveCollection,
  searchTerm: string | null,
): Promise<IGetFiltersResult> =>
  new Promise<IGetFiltersResult>((resolve) => {
    const response: IGetFiltersResult = {
      raw: null,
      filters: [],
    };

    try {
      const params: Record<string, string> = {
        q: searchTerm ?? '',
        collection_id: activeCollection.id ?? '',
        collection_handle: activeCollection.handle ?? '',
        filters_only: 'true',
      };

      const basePath =
        activeCollection && activeCollection.handle
          ? `/collections/${activeCollection.handle}`
          : '/search';

      const url = `${basePath}?view=app-layer-search&${new URLSearchParams(
        params,
      ).toString()}`;

      fetch(url, {
        headers: {
          Accept: 'application/json',
        },
      })
        .then((r) => r.text())
        .then((text) => {
          try {
            const data = JSON.parse(text);
            response.raw = data;

            if (Array.isArray(data.filters)) {
              response.filters = data.filters as ISearchFilter[];
            }
          } catch (parseError) {
            console.error('ShopifySearch:GetFilters JSON parse error', {
              url,
              preview: text ? text.substring(0, 200) : '',
              error: parseError,
            });
          }

          resolve(response);
        })
        .catch((e) => {
          console.error('ShopifySearch:GetFilters request error', { url, error: e });
          resolve(response);
        });
    } catch (e) {
      console.error(e);
      resolve(response);
    }
  });

export default GetFilters;

